module.exports = __webpack_public_path__ + "static/media/storefront.355f1caf.jpg";